//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
export default {
  name: "assess-report",
  components:{
    divSpan
  },
  data(){
    return{
      tabIndex:1,
      wrapperHeight:0,
      allLoaded:false,
      config:{
        title:'供应商考核',
        url:'api/sup-ass-result/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'考核方案编号/名称',
          searchCondition:'key',
          rules:[{field:"supAssTask.supAssPlan.name-supAssTask.supAssPlan.code",option: "LIKE_ANYWHERE"}]
        },
      },
      list:[]
    }
  },
  methods:{
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function() {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop(){
      this.$refs.header.getlist(true);
    },
    loadBottom(){
      this.$refs.header.getMore();
    },
    getWorkFlow(){
      this.$refs.header.getlist();
    }
  },
  mounted(){
    this.init()
    this.$refs.header.tabIndex=this.$route.query.tabIndex||1;
    this.tabIndex=this.$route.query.tabIndex||1;
    this.getWorkFlow()
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier-assess/mine-assess.vue